import { Text, FocusTrap } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";
import LicenciadaForm from "../../components/licenciada-form";
import { TLicenciadaForm } from "../../firestore";

const LicenciadaFormModal = ({ context, innerProps, id }: ContextModalProps<{ item: TLicenciadaForm }>) => {
  const { item: licenciada } = innerProps;
  /**
   * Handle success
   */
  function onSuccess() {
    context.closeModal(id);
  }

  return (
    <FocusTrap active={true}>
      <Text fw="bold" mb="md">
        Editar Licenciada
      </Text>
      <LicenciadaForm licenciada={licenciada} onSuccess={onSuccess} />
    </FocusTrap>
  );
};

export default LicenciadaFormModal;
